// extracted by mini-css-extract-plugin
export default {"containers":"modules_containers__7GlMj","inner":"modules_inner__zfBYQ","module_box":"modules_module_box__kc+pY"};